// import ExamBook from "../../../assets/images/book.svg";
import useStyles from "../styles";
import PropTypes from "prop-types";
// import Timer from "../../../assets/images/timer.svg";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";

const StudentExaminationCard = ({ examtitle, examdesc, duration, examlink, status }) => {
  const classes = useStyles();
  const isSubmitted = String(status ?? "").trim().toLowerCase() === "submitted";

  return (
    <div className={`${classes.cardcont} text-align-left`}>
      <div className="flex-start justify-items-space">
        <div>
          <h3>{examtitle}</h3>
          <p>{examdesc}</p>
        </div>
        <div className={`${classes.durationcont} flex gap-10 align-items-start`}>
          <Icon icon="iconamoon:clock-fill" width="18" height="18" style={{ color: "#0065FF" }} />
          <p>{duration}</p>
        </div>
      </div>
      <div>
        {isSubmitted ? (
          <div className={classes.examCardFooter}>
            <span className={classes.submittedStatusTag}>Submitted</span>
          </div>
        ) : (
          <div className={classes.itembottom}>
            <Link className={classes.examlink} to={examlink}>Start Exam</Link>
          </div>
        )}
      </div>
    </div>
  );
};
StudentExaminationCard.PropTypes = {
  examlink: PropTypes.string,
  examtitle: PropTypes.string,
  examdesc: PropTypes.string,
  duration: PropTypes.string,
  status: PropTypes.string
};

export default StudentExaminationCard;
